import { create } from 'zustand';

interface ToolsDocsState {
	isExpanded: boolean;
	toggle: () => void;
}

export const useToolsDocsStore = create<ToolsDocsState>()((set) => ({
	isExpanded: false,
	toggle: (): void => set((state) => ({ isExpanded: !state.isExpanded })),
}));
